import * as Component from 'components';
import { seasonService } from 'content/service';
import React from 'react';

interface SeasonBulkDistributionButtonProps {
  selectedList: number[];
}

const SeasonBulkDistributionButton = ({ selectedList }: SeasonBulkDistributionButtonProps) => {
  const handleBulkDistribution = async (
    selectedList: number[],
    contentConsumerName: string
  ): Promise<void> => {
    if (selectedList.length === 0) {
      alert('Please select at least one Season');
      return;
    }
    try {
      await seasonService.bulkDistribution(selectedList, contentConsumerName);
      window.location.reload();
    } catch (error) {
      console.error('Failed to add distribution:', error);
      alert('Failed to add distribution');
    }
  };

  return (
    <>
      <Component.CustomButtonComponent
        key="bulk-distribution"
        text="+ Add Amasian Distribution"
        onClick={() => {
          handleBulkDistribution(selectedList, 'amasian');
        }}
        size="small"
      />
      <Component.CustomButtonComponent
        key="bulk-distribution-staging"
        text="+ Add Amasian-Staging Distribution"
        onClick={() => {
          handleBulkDistribution(selectedList, 'amasian-staging');
        }}
        size="small"
      />
    </>
  );
};

export default SeasonBulkDistributionButton;
